import { z } from "zod";

const required_error = "This field is required";

// Video Carousel Banner
export const VideoCarouselBannerInputSchema = z.object({
	template: z.literal("videoBanner"),

	bannerType: z.enum(["internal", "sponsored"]).default("internal").nullable(),

	videoUuid: z.string().min(1, "This field is required").uuid().nullable(),

	headingText: z.string().nullish(),

	subheadingText: z.string().nullish(),

	name: z.string().min(1, "This field is required").nullable()
});

export const VideoCarouselBannerOutputSchema = z.object({
	id: z.number(),

	template: z.literal("videoBanner"),

	bannerType: z.enum(["internal", "sponsored"]).nullable(),

	videoUuid: z.string().uuid().nullable(),

	headingText: z.string().nullish(),

	subheadingText: z.string().nullish(),

	name: z.string().nullable(),

	activeDays: z.number(),

	createdBy: z
		.object({
			id: z.number(),

			firstName: z.string(),

			lastName: z.string()
		})
		.nullable(),

	updatedAt: z.coerce.date(),

	createdAt: z.coerce.date()
});

export type VideoCarouselBannerInput = z.infer<
	typeof VideoCarouselBannerInputSchema
>;

export type VideoCarouselBannerModel = z.infer<
	typeof VideoCarouselBannerOutputSchema
>;
